import is from 'is_js';
export default function getStateFromObject({
  data = {},
  model = 'user'
}) {
  let state = {};
  Object.keys(data).forEach(function (prop) {
    const element = data[prop];
    parse(element, prop);
  });
  return state;
  function parseObject(object, base) {
    Object.keys(object).forEach(function (prop) {
      const pattern = base + '[' + prop + ']';
      const element = object[prop];
      parse(element, pattern);
    });
  }
  function parseArray(array, base) {
    array.forEach(function (element, i) {
      const pattern = base + '[' + i + ']';
      parse(element, pattern);
    });
  }
  function parse(element, pattern) {
    if (is.array(element)) {
      parseArray(element, pattern);
    } else if (is.json(element)) {
      parseObject(element, pattern);
    } else {
      let final_pattern = model !== '' ? model + '[' + pattern.split('[', 1)[0] + ']' : pattern;
      let index_of_bracket = pattern.indexOf('[');
      if (index_of_bracket > 0 && model !== '') {
        final_pattern += pattern.slice(index_of_bracket);
      }
      state[final_pattern] = element;
    }
  }
}
